var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "upload__container" }, [
    _c("input", {
      ref: "file",
      attrs: { type: "file", accept: _vm.fileAcceptedTypes, hidden: "" },
      on: {
        click: function($event) {
          $event.target.value = null
        },
        change: _vm.change
      }
    }),
    _vm._v(" "),
    _vm.type == "image"
      ? _c(
          "div",
          {
            staticClass: "image__container",
            style: _vm.fileStyle,
            on: { click: _vm.upload }
          },
          [
            !_vm.image_src
              ? _c("span", { staticClass: "img__icon" }, [
                  _c("i", { staticClass: "far fa-image" })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.image_src
              ? _c("span", [_vm._v("Upload New Picture")])
              : _vm._e(),
            _vm._v(" "),
            _vm.image_src
              ? _c("img", { attrs: { src: _vm.image_src, alt: "" } })
              : _vm._e()
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.fileName && _vm.type != "image"
      ? _c("div", { staticClass: "file_label" }, [
          _vm._v(_vm._s(_vm.label)),
          _vm.required
            ? _c("span", { staticClass: "required_mark" }, [_vm._v("*")])
            : _vm._e(),
          _vm._m(0)
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type != "image"
      ? _c("div", { staticClass: "file__container", style: _vm.fileStyle }, [
          _c("span", [
            _vm._v(_vm._s(_vm.fileName ? _vm.fileName : _vm.label)),
            _vm.required && !_vm.fileName
              ? _c("span", { staticClass: "required_mark" }, [_vm._v("*")])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "file_icons" }, [
            _c("span", { on: { click: _vm.upload } }, [
              _c("i", { staticClass: "fas fa-upload" })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "remove", on: { click: _vm.remove } }, [
              _c("i", { staticClass: "fas fa-times-circle" })
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.upload_info
      ? _c("span", { staticClass: "upload__info" }, [
          _vm._v(_vm._s(_vm.upload_info))
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.fileError ? _c("small", [_vm._v(_vm._s(_vm.fileError))]) : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "check_mark" }, [
      _c("i", { staticClass: "fas fa-check" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d5affad", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d5affad","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/Upload.vue
// module id = null
// module chunks = 